import { render, staticRenderFns } from "./NavBarNew.vue?vue&type=template&id=a5825192&scoped=true"
import script from "./NavBarNew.vue?vue&type=script&lang=js"
export * from "./NavBarNew.vue?vue&type=script&lang=js"
import style0 from "./NavBarNew.vue?vue&type=style&index=0&id=a5825192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5825192",
  null
  
)

export default component.exports